import Content from "components/Content";
import React, { FC } from "react";

import TableDesktop from "../../../../../public/pricing/why-hh/table_desktop.svg";
import TableMobile from "../../../../../public/pricing/why-hh/table_mobile.svg";

import styles from "./styles.module.scss";

const WhyHH: FC = () => {
  return (
    <Content contentClassName={styles.container}>
      <TableDesktop className={`${styles.desktopTable} ${styles.table}`} />
      <TableMobile className={`${styles.responsiveTable} ${styles.table}`} />
    </Content>
  );
};

export default WhyHH;
